/**
 * Utility function to hide the Humio inner navigation element in iframe content
 * This function searches for a nav element with class 'area-mezzanine' and hides it
 * Specifically targets the 'humio-ui' iframe element
 * @param options - Configuration options for retry behavior
 * @param options.maxRetries - Maximum number of attempts (default: 100)
 * @param options.intervalMs - Interval between attempts in milliseconds (default: 200)
 */
export const hideHumioInnerNav = (options?: {
  maxRetries?: number;
  intervalMs?: number;
}): void => {
  const { maxRetries = 100, intervalMs = 200 } = options || {};
  let tries = 0;

  const interval = setInterval(() => {
    const iframe = document.getElementById('humio-ui') as
      | HTMLIFrameElement
      | undefined;
    const iframeDoc = iframe?.contentWindow?.document;
    const target = iframeDoc?.querySelector(
      'nav.area-mezzanine',
    ) as HTMLElement;
    if (iframeDoc?.readyState === 'complete' && target) {
      target?.style.setProperty('display', 'none', 'important');
      clearInterval(interval);
    } else if (tries > maxRetries) {
      clearInterval(interval);
      console.error('Failed to hide Humio inner navigation');
    }
    tries++;
  }, intervalMs);
};
